/* global I18n */

import React from "react"
import class_names from "classnames"
import signals from "signals"
import modal from "modal"

function StartQuizButton({on_click, tracking_data, disabled}) {
  function on_link_click(e) {
    if (disabled) {
      return e.preventDefault()
    } else if (!window.gon.current_user) {
      modal("#quiz_reg_wall_modal")
      return false
    }
    signals.emit("kenhub.quiz_start_clicked", tracking_data)
    return on_click(e)
  }
  const class_name = class_names("btn btn-primary", {"btn-disabled": disabled})
  return (
    <a onClick={on_link_click} className={class_name}>
      {I18n.t("js.embedded_quiz.start_quiz")}
    </a>
  )
}

export default StartQuizButton
